const masthead = document.querySelector('.global-header');
let scrollPos = 0;

window.addEventListener('scroll', e => {
  let scrolled = document.querySelector('.global-header--scrolled');

  if (window.scrollY < 128) {
    masthead.classList.remove('global-header--hidden', 'global-header--visible')
  } else if ((document.body.getBoundingClientRect()).top > scrollPos) {
    if (scrolled === null) {
      masthead.classList.remove('global-header--hidden')
      masthead.classList.add('global-header--visible')
    } else if ((scrolled !== null) && (scrolled.classList.contains('scrolled'))) {
      masthead.classList.remove('global-header--visible')
      masthead.classList.add('global-header--hidden')
    }
  } else {
    masthead.classList.remove('global-header--visible')
    masthead.classList.add('global-header--hidden')
  }
  scrollPos = (document.body.getBoundingClientRect()).top;
});
